module.exports = __webpack_public_path__ + "assets/img/22_1307.0da745f7.jpg";